import React, { useState, useEffect } from "react";
import { Flex, Box, Heading, Text, Stack, HStack, Button, Input, FormLabel, FormControl } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from 'yup';
import axios from 'axios';
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars";

function AddressDetails() {
    const userid = parseInt(useParams().userid);
    const cartid = parseInt(useParams().cartid);
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')) === null) {
        window.location.replace("/unauthorized");
    }

    // retrieve userDetails from localstorage
    const theToken = localStorage.getItem('token');

    const [userInfo, setUserInfo] = useState('');

    // access backend to retrieve user detail entered when sign up
    const getUserInfo = async () => {
        axios.get(`${CommonVars.API_URL}/users/${userid}/`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setUserInfo(res.data[0]);
        })
        .catch((error) => {
            console.log(error);
            if(error.response.status === 401) {
                window.location.replace("/unauthorized");
            }
        })
    }

    useEffect(() => {
        getUserInfo();
    });

    return (
        <Formik
            initialValues={{
                address: '',
            }}
            validationSchema={Yup.object({
                address: Yup.string()
                .matches(/\d{1,3}.?\d{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/, "Address entered is invalid")
                .required('Shipping address is required'),
            })}
            onSubmit = {(values, { setSubmitting }) => {
                const addressInput = values.address;
                const aToken = localStorage.getItem('token');
                setTimeout(() => {
                    axios.get(`${CommonVars.API_URL}/users/${userid}/cart/${cartid}`, { headers: { Authorization: `Bearer ${aToken}` } })
                        .then((res) => {
                            const totalA = res.data[0].total;

                            console.log(totalA);
                            setSubmitting(false);
                            window.location.replace(`/users/${userid}/cart/${cartid}/payment?address=${addressInput}&total=${totalA}`);
                        })
                        .catch((error) => {
                            console.log(error);
                            setSubmitting(false);
                        })
                }, 600)
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                        <Stack align={'center'}>
                            <Heading fontSize={'4xl'}>Shipping Address Details</Heading>
                            <Text fontSize={'lg'} color={'gray.600'} pt={2}>
                                Your order will be shipped to the address provided below.
                            </Text>
                        </Stack>
                        <Box
                            rounded={'lg'}
                            bg={'white'}
                            boxShadow={'lg'}
                            p={8}
                        >
                            <Form>
                                <Stack>
                                    {/* Inputs are disable for user to check their information only */}
                                    <FormControl>
                                        <Box pb={3}>
                                        <FormLabel>Username</FormLabel>
                                        <Input variant='filled' placeholder={`${userInfo.username}`} size='md' disabled/>
                                        </Box>
                                        <FormLabel>Email</FormLabel>
                                        <Input variant='filled' placeholder={`${userInfo.email}`} size='md'  disabled/>
                                    </FormControl>
                                    {/* Shipping address and Postal code Input */}
                                    <CustomFormInput
                                        label="Shipping address and postal code" 
                                        name="address" 
                                        type="text"
                                        placeholder="eg. 40 Example Road Singapore 807361"
                                    />
                                </Stack>
                                {/* Form buttons */}
                                <HStack spacing='20px' pt={8}>
                                    <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Proceed'}</Button>
                                    <Button type='reset'>Reset</Button>
                                </HStack>
                            </Form>
                        </Box>
                    </Stack>
                </Flex>
            )}
        </Formik>
    )
}

export default AddressDetails;